import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import axios from 'axios';
import InputMask from 'react-input-mask';
import readXlsxFile from 'read-excel-file';
import { toast } from 'react-toastify';
import { Modal, Button, Card, Row, Col, Statistic, Form, Input, Select, Switch, Alert, Upload, Tooltip, Tag } from 'antd';
import { UserOutlined, TeamOutlined, UploadOutlined, PlusOutlined, CheckOutlined, LoadingOutlined, DownloadOutlined } from '@ant-design/icons';
import Joyride from 'react-joyride';
import validator from 'validator';

import {
  editarCamposContrato,
  obterContratoPeloUsuario,
} from '../actions/ContratoActions';
import { consultarTurmas } from '../actions/TurmaActions';
import { cadastrarAcao } from '../actions/AcaoActions';
import ConfirmationModal from '../components/ConfirmationModal';
import {
  deletarFormando,
  obterFormandosPeloContrato,
  adicionarFormando,
  editarFormando,
  editarFormandoEUsuario,
  adicionarFormandoECriarUsuario,
} from '../actions/FormandoActions';
import EmailService from '../services/EmailService';
import TabelaFormandos from '../components/TabelaFormandos';
import { REQUEST_URL } from '../config/urls';

const { Option } = Select;

class Formandos extends React.Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
  }

  state = {
    contratos: [],
    iniciar: true,
    inputFile: null,
    formandoSelecionado: null,
    showModalFormando: false,
    showModalNotificacao: false,
    showModalCursoNaoCadastrado: false,
    operacao: 'adicionar',
    botaoFinalizar: false,
    formando: {
      nome: '',
      email: '',
      celular: '',
      documento: "",
      dataNascimento: "",
      contrato: 0,
      turma: null,
      membroComissao: false,
      usuario: 0,
    },
    formandos: [],
    cursoSelecionadoPlanilha: [],
    botaoCadastrarFormandosPorPlanilha: false,
    turmasSelect: [],
    run: false,
    steps: [
      {
        content: (
          <div>
            <h3>Bem-vindo(a) a página de cadastro dos formandos!</h3>{' '}
            <span style={{ textAlign: 'center' }}>
              É aqui que você conseguirá gerenciar as informações dos formandos.
            </span>
          </div>
        ),
        placement: 'center',
        target: '#divContent',
      },
      {
        content: (
          <div>
            <h3>Cadastrar formandos pela planilha</h3>{' '}
            <span style={{ textAlign: 'center' }}>
              Você pode adicionar vários formandos de uma vez clicando aqui.
            </span>
          </div>
        ),
        placement: 'bottom',
        target: '#formandoPlanilha',
      },
      {
        content: (
          <div>
            <h3>Cadastrar formandos manualmente</h3>{' '}
            <span style={{ textAlign: 'center' }}>
              Você também pode adicioná-los de forma manual clicando aqui.
            </span>
          </div>
        ),
        placement: 'bottom',
        target: '#formandoManual',
      },
      {
        content: (
          <div>
            <h3>Finalização da etapa</h3>{' '}
            <span style={{ textAlign: 'center' }}>
              Após adição de todos os formandos, finalize a etapa clicando neste
              botão!
            </span>
          </div>
        ),
        target: '#btnFinalizarEtapa',
      },
    ],
  };

  async componentDidMount() {
    this._isMounted = true;
    if (this.props.usuario_a.tipo === 'comissao') {
      await this.iniciar();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  async iniciar() {
    try {
      await this.props.obterContratoPeloUsuario(this.props.usuario_a.id);

      if (!this._isMounted) return;

      if (this.props.contrato) {
        let turmas = [],
          formandos = [];
        if (
          this.props.contrato.turmas &&
          this.props.contrato.turmas.length > 0
        ) {
          if (this.props.contrato.cadastrouFormandos === 0) {
            this.setState({ run: true });
          }
          this.props.contrato.turmas.forEach((turma) => {
            turmas.push({ value: turma.id, label: turma.curso });
            turma.formandos.forEach((formando) => {
              formandos.push({
                id: formando.id,
                nome: formando.nome,
                email: formando.email,
                celular: formando.celular,
                documento: formando.documento,
                dataNascimento: formando.dataNascimento,
                turma: turma.id,
                curso: turma.curso,
                usuario: formando.usuario,
                membroComissao: formando.membroComissao,
              });
            });
          });
          formandos.sort((a, b) => {
            return a.nome.toLowerCase() > b.nome.toLowerCase() ? 1 : -1;
          });
          if (this._isMounted) {
            this.setState({ turmasSelect: turmas, formandos });
          }
        } else {
          if (this._isMounted) {
            this.setState({ showModalCursoNaoCadastrado: true });
          }
        }
      }
      if (this._isMounted) {
        this.setState({ iniciar: false });
      }
    } catch (error) {
      console.error('Erro ao iniciar formandos:', error);
      if (this._isMounted) {
        this.setState({ iniciar: false });
      }
    }
  }

  async finalizar() {
    let email = new EmailService(),
      data = { cadastrouFormandos: 1, confirmarPlanilha: 1 };
    this.setState({ botaoFinalizar: true });

    // Aguardar a atualização do contrato
    await this.props.editarCamposContrato(this.props.contrato.id, data);

    // Recarregar o contrato atualizado
    await this.props.obterContratoPeloUsuario(this.props.contrato.usuario.id);

    //cadastrar notificação para admistração
    let acao = {
      ator: this.props.contrato.dono.id,
      texto: `Comissão confirmou o cadastro de formandos para o contrato ${this.props.contrato.numero}`,
      data: new Date(),
      contrato: this.props.contrato.id,
      tipo: 'comissao',
      visualizado: false,
    };
    email.enviar('updateAcaoComissaoToDesigner', {
      numero: this.props.contrato.numero,
      mensagem: 'o cadastro de formandos',
      designer: { email: this.props.contrato.dono.email },
    });
    this.props.cadastrarAcao(acao);
    this.setState({ botaoFinalizar: false, showModalNotificacao: true, showModalFinalizar: false });
  }

  async salvar(event) {
    event.preventDefault();
    let formando = this.state.formando;

    formando.turma = formando.turma.value;
    formando.celular = Number(
      String(formando.celular).replace(/[()-.+\s]/g, '')
    );

    if (formando.turma) {
      if (validator.isEmail(formando.email)) {
        if (this.state.operacao === 'adicionar') {
          formando.contrato = this.props.contrato.id;
          formando.continuarDepois = false;
          if (
            !this.props.contrato.contratante.includes('Alpha-e') &&
            this.props.contrato.sistemaPagto === 1
          ) {
            this.props.adicionarFormandoECriarUsuario(formando).then(() => {
              toast.success('Formando cadastrado com sucesso!');
              let acao = {
                ator: this.props.contrato.dono.id,
                texto: `O formando ${formando.nome} foi adicionando no contrato ${this.props.contrato.numero} e o usuário foi gerado automaticamente.`,
                data: new Date(),
                contrato: this.props.contrato.id,
                tipo: 'atrasado',
                visualizado: false,
              };
              this.props.cadastrarAcao(acao);
              this.resetar();
              this.iniciar();
            });
          } else {
            delete formando.usuario;
            this.props.adicionarFormando(formando).then(() => {
              toast.success('Formando cadastrado com sucesso!');
              let acao = {
                ator: this.props.contrato.dono.id,
                texto: `O formando ${formando.nome} foi adicionando no contrato ${this.props.contrato.numero}.`,
                data: new Date(),
                contrato: this.props.contrato.id,
                tipo: 'atrasado',
                visualizado: false,
              };
              this.props.cadastrarAcao(acao);
              this.resetar();
              this.iniciar();
            });
          }
        } else {
          if (formando.usuario) {
            await this.props.editarFormandoEUsuario(formando);
          } else {
            delete formando.usuario;
            await this.props.editarFormando(formando);
          }
          await this.resetar();
          await this.iniciar();
          toast.success('Formando alterado com sucesso!');
        }
      } else {
        toast.info(`Informe um e-mail válido!`);
      }
    } else {
      toast.info(`Selecione um curso!`);
    }
  }

  async resetar() {
    this.setState({
      showModalFormando: false,
      operacao: "adicionar",
      formandoSelecionado: null,
      formando: {
        nome: "",
        email: "",
        celular: "",
        documento: "",
        dataNascimento: "",
        turma: {},
        usuario: 0
      }
    });
  }

  async deletar() {
    await this.props.deletarFormando(this.state.formandoSelecionado);
    await this.resetar();
    await this.iniciar();
  }

  handleClickEditar = (formando) => {
    formando = {
      id: formando.id,
      nome: formando.nome,
      email: formando.email,
      celular: formando.celular,
      documento: formando.documento || "",
      dataNascimento: formando.dataNascimento || "",
      contrato: this.props.contrato.id,
      usuario: formando.usuario,
      membroComissao: formando.membroComissao,
      turma: {
        value: formando.turma,
        label: formando.curso,
      },
    };
    this.setState({ operacao: 'editar', formando, showModalFormando: true });
  };

  handleClickDelete = (id) => {
    this.setState({ formandoSelecionado: id });
    this.refs.modal.open();
  };

  async carregarListaFormandos() {
    const selectedFile = this.state.selectedFile;

    if (!selectedFile) {
      toast.error("Insira a planilha preenchida com as informações dos formandos!");
      return;
    }

    if (!this.state.cursoSelecionadoPlanilha || !this.state.cursoSelecionadoPlanilha.value) {
      toast.error("Selecione o curso que os formandos pertencem!");
      return;
    }

    this.setState({ botaoCadastrarFormandosPorPlanilha: true });
    let erroAoCadastrarFormandos = false;
    let formandosAdicionados = 0;

    try {
      const cols = await readXlsxFile(selectedFile);

      if (!cols || cols.length <= 1) {
        toast.error("A planilha está vazia ou não contém dados válidos!");
        return;
      }

      const comSistemaPagto = !this.props.contrato.contratante.includes("Alpha-e") && this.props.contrato.sistemaPagto === 1;

      for (let i = 1; i < cols.length; i++) {
        const col = cols[i];

        // 0: Nome, 1: E-mail, 2: Celular, 3: Membro da Comissão (sim/não), 4: CPF, 5: Data de Nascimento
        if (col[0] == null || col[1] == null || col[2] == null || col[3] == null || col[4] == null) {
          toast.error(`Erro na linha ${i + 1}: campos obrigatórios faltando!`);
          erroAoCadastrarFormandos = true;
          continue;
        }

        if (!validator.isEmail(String(col[1]))) {
          toast.error(`Erro na linha ${i + 1} (${col[0]}): e-mail inválido!`);
          erroAoCadastrarFormandos = true;
          continue;
        }

        const formando = {
          nome: col[0],
          email: String(col[1]),
          celular: Number(String(col[2]).replace(/[()-.+\s]/g, "")),
          membroComissao: String(col[3]).toLowerCase().includes("s") ? 1 : 0,
          documento: String(col[4]).replace(/[.-]/g, ""),
          dataNascimento: col[5] || "",
          turma: this.state.cursoSelecionadoPlanilha.value,
          contrato: this.props.contrato.id,
          continuarDepois: true
        };

        try {
          if (comSistemaPagto) {
            // Cria usuário primeiro, depois formando — em série via axios direto
            const usuarioResp = await axios.post(`${REQUEST_URL}/usuarios`, {
              login: formando.email,
              senha: Math.random().toString(36).slice(-8),
              nome: formando.nome,
              tipo: 'formando',
              email: formando.email
            });
            formando.usuario = usuarioResp.data.id;
            await axios.post(`${REQUEST_URL}/formandos`, formando);
          } else {
            await axios.post(`${REQUEST_URL}/formandos`, formando);
          }
          formandosAdicionados++;
        } catch (error) {
          toast.error(`Erro ao adicionar ${col[0]}: ${error.response?.data?.error || error.message || 'Erro desconhecido'}`);
          erroAoCadastrarFormandos = true;
        }
      }

      await this.iniciar();

      if (erroAoCadastrarFormandos && formandosAdicionados > 0) {
        toast.info(`${formandosAdicionados} formando(s) cadastrado(s). Alguns não puderam ser cadastrados.`);
      } else if (formandosAdicionados > 0) {
        toast.success(`${formandosAdicionados} formando(s) cadastrado(s) com sucesso!`);
      } else if (!erroAoCadastrarFormandos) {
        toast.warning("Nenhum formando foi cadastrado.");
      }

    } catch (error) {
      toast.error("Erro ao processar a planilha. Verifique se o arquivo está no formato correto.");
      console.error("Erro ao ler planilha:", error);
    } finally {
      const uploadInput = document.querySelector("#upload");
      if (uploadInput) uploadInput.value = "";
      const fakeInput = document.querySelector("#fakeInput");
      if (fakeInput) fakeInput.value = "";
      this.setState({ botaoCadastrarFormandosPorPlanilha: false, cursoSelecionadoPlanilha: [], selectedFile: null, fileName: '' });
    }
  } handleChangeCurso(turmaSelecionada) {
    this.setState({
      formando: { ...this.state.formando, turma: turmaSelecionada },
    });
  }

  handleChangeMembroComissao() {
    this.setState({
      formando: {
        ...this.state.formando,
        membroComissao: !this.state.formando.membroComissao,
      },
    });
  }

  handleChangeCursoSelecionadoPlanilha(cursoSelecionadoPlanilha) {
    this.setState({ cursoSelecionadoPlanilha });
  }

  handleChangeFormando = (e) => {
    const { name, value } = e.target;

    this.setState({ formando: { ...this.state.formando, [name]: value } });
  };

  handleClickReenviarEmail = async (formando) => {
    await axios
      .get(`${REQUEST_URL}/formandos/${formando.usuario}/pegar-usuario`)
      .then((response) => {
        new EmailService().enviar('formando', {
          usuario: { ...response.data[0] },
        });
        toast.success('E-mail enviado com sucesso!');
      })
      .catch((err) => {
        toast.error('Este usuário não possui acesso ao sistema!');
      });
  };

  uploadSpreadsheet() {
    const file = document.querySelector('#upload');
    if (file) {
      file.click();
    }
  }

  handleFileChange = (e) => {
    const file = e.target;
    const fakeInput = document.querySelector('#fakeInput');
    if (fakeInput && file.value) {
      fakeInput.value = file.value.replace(/C:\\fakepath\\/i, '');
    }
    if (e.target.files && e.target.files[0]) {
      this.setState({ selectedFile: e.target.files[0] });
    }
  }

  _renderCards() {
    let numUsuarios = this.state.formandos.length,
      numUsuariosComAcesso = this.state.formandos.filter((f) => {
        return f.usuario;
      }).length;

    const cardStyle = {
      borderRadius: '12px',
      border: 'none',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
      height: '100%',
    };

    return (
      <Row gutter={[24, 24]} style={{ marginBottom: 24 }}>
        <Col xs={24} sm={12} md={12} lg={12}>
          <Card bordered={false} style={cardStyle}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{
                backgroundColor: '#ffebee',
                borderRadius: '50%',
                padding: '16px',
                marginRight: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minWidth: '64px',
                minHeight: '64px'
              }}>
                <UserOutlined style={{ fontSize: '28px', color: '#d32f2f' }} />
              </div>
              <div>
                <div style={{ color: '#757575', fontSize: '14px', fontWeight: 500 }}>Formandos Cadastrados</div>
                <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#212121' }}>
                  {numUsuariosComAcesso}
                  <span style={{ fontSize: '16px', color: '#9e9e9e', fontWeight: 'normal', marginLeft: 8 }}>/ {numUsuarios}</span>
                </div>
                <div style={{ color: '#4caf50', fontSize: '12px', marginTop: 4 }}>
                  <CheckOutlined /> Com acesso ao sistema
                </div>
              </div>
            </div>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={12} lg={12}>
          <Card bordered={false} style={cardStyle}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{
                backgroundColor: '#e0e0e0',
                borderRadius: '50%',
                padding: '16px',
                marginRight: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minWidth: '64px',
                minHeight: '64px'
              }}>
                <TeamOutlined style={{ fontSize: '28px', color: '#424242' }} />
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ color: '#757575', fontSize: '14px', fontWeight: 500 }}>Turmas Vinculadas</div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                  <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#212121' }}>
                    {this.state.turmasSelect.length}
                  </div>
                  <Button
                    type="link"
                    onClick={() => this.setState({ showModalTurmas: true })}
                    style={{ padding: 0, color: '#d32f2f', fontWeight: 500 }}
                  >
                    Visualizar
                  </Button>
                </div>
                <div style={{ color: '#9e9e9e', fontSize: '12px', marginTop: 4 }}>
                  Cursos associados ao contrato
                </div>
              </div>
            </div>
          </Card>
        </Col>
      </Row>
    );
  }

  render() {
    if (this.props.usuario_a.tipo === 'formando') {
      return <Redirect to='/' />;
    }

    const primaryColor = '#d32f2f'; // Company Red
    const secondaryColor = '#212121'; // Company Black

    // Custom Button Styles
    const primaryBtnStyle = { backgroundColor: primaryColor, borderColor: primaryColor, borderRadius: '6px', fontWeight: 500 };
    // const dangerBtnStyle = { backgroundColor: '#fff', borderColor: primaryColor, color: primaryColor, borderRadius: '6px', fontWeight: 500 };

    // Modal Finalizar Etapa
    const modalFinalizar = (
      <Modal
        title={<span style={{ fontWeight: 'bold' }}>Finalizar Etapa</span>}
        visible={this.state.showModalFinalizar}
        onCancel={() => this.setState({ showModalFinalizar: false })}
        footer={[
          <Button key="back" onClick={() => this.setState({ showModalFinalizar: false })} style={{ borderRadius: '6px' }}>
            Cancelar
          </Button>,
          <Button key="submit" type="primary" danger onClick={this.finalizar.bind(this)} loading={this.state.botaoFinalizar} style={{ borderRadius: '6px', backgroundColor: primaryColor, borderColor: primaryColor }}>
            Confirmar
          </Button>
        ]}
        centered
      >
        <div style={{ textAlign: 'center', padding: '20px 0' }}>
          <TeamOutlined style={{ fontSize: 48, color: primaryColor, marginBottom: 16 }} />
          <p style={{ fontSize: '16px' }}>
            Confirme se todas as pessoas que personalizarão o convite
            (formandos, homenageados e professores) foram cadastradas e
            possuem e-mails válidos antes de finalizar essa etapa!
          </p>
        </div>
      </Modal>
    );

    // Modal Upload
    const modalUpload = (
      <Modal
        title={<span style={{ fontWeight: 'bold' }}>Cadastro via Planilha</span>}
        visible={this.state.showModalUpload}
        onCancel={() => this.setState({ showModalUpload: false })}
        footer={[
          <Button key="back" onClick={() => this.setState({ showModalUpload: false })} style={{ borderRadius: '6px' }}>
            Cancelar
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={this.carregarListaFormandos.bind(this)}
            loading={this.state.botaoCadastrarFormandosPorPlanilha}
            style={{ ...primaryBtnStyle }}
          >
            Enviar Dados
          </Button>
        ]}
        centered
        width={600}
      >
        <Alert
          message="Instruções Importantes"
          description={
            <div>
              <p>
                Para importar seus formandos, utilize nossa planilha modelo.
                <a href={`${process.env.PUBLIC_URL}/planilha-modelo.xlsx`} download='planilha-modelo.xlsx' style={{ color: primaryColor, fontWeight: 'bold', marginLeft: 5 }}>
                  <DownloadOutlined /> Baixar Modelo
                </a>
              </p>
              <ul style={{ paddingLeft: 20, marginTop: 10, color: '#555' }}>
                <li>Todos os campos são obrigatórios.</li>
                <li>Cada formando deve ocupar apenas uma linha.</li>
                <li>Valide os CPFs antes de enviar.</li>
              </ul>
            </div>
          }
          type="info"
          showIcon
          style={{ marginBottom: 24, borderRadius: '8px', border: '1px solid #e3f2fd', backgroundColor: '#e3f2fd' }}
        />

        <div style={{ marginBottom: 20 }}>
          <label style={{ fontWeight: 500, display: 'block', marginBottom: 8 }}>Curso / Turma <span style={{ color: primaryColor }}>*</span></label>
          <Select
            placeholder="Selecione o curso de destino"
            style={{ width: '100%' }}
            size="large"
            value={this.state.cursoSelecionadoPlanilha && this.state.cursoSelecionadoPlanilha.value}
            onChange={(val, opt) => this.handleChangeCursoSelecionadoPlanilha(opt)}
            options={this.state.turmasSelect}
          />
        </div>

        <div style={{ marginBottom: 15 }}>
          <label style={{ fontWeight: 500, display: 'block', marginBottom: 8 }}>Arquivo Excel <span style={{ color: primaryColor }}>*</span></label>

          <div style={{ display: 'flex', gap: 10 }}>
            <Input
              disabled
              value={this.state.fileName || ''}
              placeholder="Nenhum arquivo selecionado"
              style={{ flex: 1 }}
            />
            <Button
              icon={<UploadOutlined />}
              onClick={() => document.getElementById('upload').click()}
            >
              Selecionar
            </Button>
          </div>

          <input
            type='file'
            id='upload'
            accept='.xlsx,.xls'
            style={{ display: 'none' }}
            onChange={(e) => {
              this.handleFileChange(e);
              if (e.target.files && e.target.files[0]) {
                this.setState({ fileName: e.target.files[0].name });
              }
            }}
          />
          <input type='hidden' id='fakeInput' />
        </div>
      </Modal>
    );

    // Modal Formando (Adicionar/Editar)
    const modalFormando = (
      <Modal
        title={<span style={{ fontWeight: 'bold' }}>{this.state.operacao === 'editar' ? 'Editar Formando' : 'Novo Formando'}</span>}
        visible={this.state.showModalFormando}
        onCancel={this.resetar.bind(this)}
        footer={[
          <Button key="back" onClick={this.resetar.bind(this)} style={{ borderRadius: '6px' }}>
            Cancelar
          </Button>,
          <Button key="submit" type="primary" onClick={this.salvar.bind(this)} style={{ borderRadius: '6px', backgroundColor: primaryColor, borderColor: primaryColor }}>
            Salvar
          </Button>
        ]}
        centered
        width={700}
      >
        <Form layout="vertical">
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item label={<span style={{ fontWeight: 500 }}>Nome Completo</span>} required>
                <Input
                  name="nome"
                  value={this.state.formando.nome}
                  className='form-control'
                  onChange={(e) => this.handleChangeFormando(e)}
                  placeholder="Ex: João da Silva"
                  size="large"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label={<span style={{ fontWeight: 500 }}>E-mail</span>} required>
                <Input
                  name="email"
                  type="email"
                  value={this.state.formando.email}
                  className='form-control'
                  onChange={(e) => this.handleChangeFormando(e)}
                  placeholder="email@exemplo.com"
                  size="large"
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label={<span style={{ fontWeight: 500 }}>CPF</span>} required>
                <InputMask
                  mask="999.999.999-99"
                  value={this.state.formando.documento}
                  onChange={(e) => this.handleChangeFormando(e)}
                  className="ant-input ant-input-lg"
                  name="documento"
                  placeholder="000.000.000-00"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label={<span style={{ fontWeight: 500 }}>Data de Nascimento</span>} required>
                <Input
                  type="date"
                  name="dataNascimento"
                  value={this.state.formando.dataNascimento}
                  onChange={(e) => this.handleChangeFormando(e)}
                  size="large"
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label={<span style={{ fontWeight: 500 }}>Celular</span>} required>
                <InputMask
                  mask="(99) 99999-9999"
                  value={this.state.formando.celular}
                  name='celular'
                  onChange={(e) => this.handleChangeFormando(e)}
                  className="ant-input ant-input-lg"
                  placeholder="(00) 00000-0000"
                />
              </Form.Item>
            </Col>
          </Row>

          {this.state.turmasSelect.length > 0 && (
            <Form.Item label={<span style={{ fontWeight: 500 }}>Curso</span>} required>
              <Select
                placeholder='Selecione a turma'
                value={this.state.formando.turma && this.state.formando.turma.value ? this.state.formando.turma.value : this.state.formando.turma}
                onChange={(val, opt) => this.handleChangeCurso(opt)}
                options={this.state.turmasSelect}
                size="large"
              />
            </Form.Item>
          )}
          <Form.Item style={{ marginBottom: 0 }}>
            <div style={{ padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '6px', display: 'inline-flex', alignItems: 'center' }}>
              <Switch
                checked={this.state.formando.membroComissao}
                onChange={this.handleChangeMembroComissao.bind(this)}
                style={{ backgroundColor: this.state.formando.membroComissao ? primaryColor : undefined }}
              />
              <span style={{ marginLeft: 10, fontWeight: 500 }}>Membro da Comissão de Formatura</span>
            </div>
          </Form.Item>
        </Form>
      </Modal>
    );

    // Modal Notificacao Sucesso
    const modalNotificacao = (
      <Modal
        visible={this.state.showModalNotificacao !== false}
        onCancel={() => this.setState({ showModalNotificacao: false })}
        footer={null}
        centered
        width={400}
        bodyStyle={{ textAlign: 'center', padding: 40 }}
      >
        <div style={{ backgroundColor: '#e8f5e9', width: 80, height: 80, borderRadius: '50%', margin: '0 auto 20px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <CheckOutlined style={{ fontSize: 40, color: '#4caf50' }} />
        </div>
        <h2 style={{ fontSize: 24, fontWeight: 'bold' }}>Sucesso!</h2>
        <p style={{ color: '#757575', fontSize: 16 }}>Cadastro de formandos finalizado com êxito.</p>
        <Button type="primary" onClick={() => this.setState({ showModalNotificacao: false })} style={{ ...primaryBtnStyle, marginTop: 10, width: '100%' }}>
          Continuar
        </Button>
      </Modal>
    );

    // Modal Info Curso
    const modalCursoNaoCadastrado = (
      <Modal
        visible={this.state.showModalCursoNaoCadastrado}
        closable={false}
        footer={null}
        centered
      >
        <div style={{ textAlign: 'center', padding: 20 }}>
          <div style={{ backgroundColor: '#fff3e0', width: 80, height: 80, borderRadius: '50%', margin: '0 auto 20px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <TeamOutlined style={{ fontSize: 40, color: '#ff9800' }} />
          </div>
          <h2 style={{ fontWeight: 'bold' }}>Atenção Necessária</h2>
          <p style={{ color: '#757575' }}>Não conseguimos encontrar o seu curso cadastrado. Por favor, entre em contato com seu atendente.</p>
          <Button type="primary" href="./" style={{ marginTop: 20, backgroundColor: secondaryColor, borderColor: secondaryColor }}>Voltar para Início</Button>
        </div>
      </Modal>
    );

    // Modal Turmas List
    const modalTurmas = (
      <Modal
        title="Turmas Cadastradas"
        visible={this.state.showModalTurmas}
        onCancel={() => this.setState({ showModalTurmas: false })}
        footer={null}
        centered
      >
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12 }}>
          {this.state.turmasSelect.map((curso, i) => (
            <Tag
              key={i}
              color="red"
              style={{ padding: '8px 16px', fontSize: 14, borderRadius: '20px', backgroundColor: '#ffebee', color: '#d32f2f', border: '1px solid #ffcdd2' }}
            >
              <span style={{ fontWeight: 'bold' }}>{curso.label}</span>
              <span style={{ marginLeft: 8, opacity: 0.8 }}>
                ({this.state.formandos.filter((formando) => formando.curso === curso.label).length})
              </span>
            </Tag>
          ))}
        </div>
      </Modal>
    );

    return (
      <div id='divContent' style={{ minHeight: '100vh', padding: '24px', backgroundColor: '#f0f2f5' }}>

        {/* Page Header Area */}
        <div style={{ marginBottom: 32, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h1 style={{ fontSize: '28px', color: '#1a1a1a', marginBottom: '8px', fontWeight: 700 }}>Gerenciamento de Formandos</h1>
            <p style={{ color: '#757575', margin: 0 }}>Gerencie as informações da turma, adicione formandos e controle acessos.</p>
          </div>
          <div>
            {this.props.contrato.cadastrouFormandos === 1 ? (
              <Tag color="success" style={{ padding: '6px 16px', fontSize: '14px', borderRadius: '4px' }}>
                <CheckOutlined /> Etapa Concluída
              </Tag>
            ) : (
              <Button
                type="primary"
                size="large"
                id='btnFinalizarEtapa'
                onClick={() => this.setState({ showModalFinalizar: true })}
                loading={this.state.botaoFinalizar}
                disabled={this.state.botaoFinalizar}
                style={{ backgroundColor: primaryColor, borderColor: primaryColor, borderRadius: '6px', fontWeight: 'bold', height: '44px', paddingLeft: 24, paddingRight: 24, boxShadow: '0 4px 14px rgba(211, 47, 47, 0.3)' }}
              >
                Concluir Cadastro
              </Button>
            )}
          </div>
        </div>

        <ConfirmationModal
          ref='modal'
          confirmButtonStyle='btn-danger'
          title='Excluir Formando'
          confirmButton='Excluir'
          body='Tem certeza que deseja remover este formando da lista? Esta ação não pode ser desfeita.'
          onConfirm={this.deletar.bind(this)}
        />

        {this._renderCards()}

        <Card
          bordered={false}
          bodyStyle={{ padding: '24px' }}
          style={{ borderRadius: '12px', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)' }}
        >
          {this.props.contrato.cadastrouFormandos === 0 && (
            <div style={{ marginBottom: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 16 }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <h3 style={{ margin: 0, fontWeight: 600, color: '#212121' }}>Lista de Formandos</h3>
                <span style={{ marginLeft: 12, backgroundColor: '#f5f5f5', padding: '4px 12px', borderRadius: '20px', fontSize: '12px', color: '#757575', fontWeight: 600 }}>
                  Total: {this.state.formandos.length}
                </span>
              </div>

              <div style={{ display: 'flex', gap: 12 }}>
                <Button
                  id='formandoPlanilha'
                  icon={<UploadOutlined />}
                  onClick={() => this.setState({ showModalUpload: true })}
                  style={{ borderRadius: '6px' }}
                >
                  Importar Planilha
                </Button>
                <Button
                  id='formandoManual'
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={() => this.setState({ showModalFormando: true })}
                  style={{ ...primaryBtnStyle }}
                >
                  Novo Formando
                </Button>
              </div>
            </div>
          )}

          <TabelaFormandos
            data={this.state.formandos}
            cadastrouFormandos={this.props.contrato.cadastrouFormandos}
            isAdmin={sessionStorage.getItem("alphaAdmin") === "true"}
            editarFormando={(formando) => this.handleClickEditar(formando)}
            excluirFormando={(id) => this.handleClickDelete(id)}
            reenviarEmail={(formando) => this.handleClickReenviarEmail(formando)}
          />
        </Card>

        {modalFinalizar}
        {modalUpload}
        {modalFormando}
        {modalNotificacao}
        {modalCursoNaoCadastrado}
        {modalTurmas}

        <Joyride
          continuous={true}
          run={this.state.run}
          scrollToFirstStep={true}
          showProgress={true}
          showSkipButton={true}
          steps={this.state.steps}
          styles={{
            options: {
              zIndex: 10000,
            },
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    usuario_a: state.usuario.autenticado,
    contrato: state.contrato.especifico,
    formandos: state.formando.todos,
    carregando: state.formando.carregando,
    turmas: state.turmas.turmas,
  };
};

export default connect(mapStateToProps, {
  cadastrarAcao,
  adicionarFormandoECriarUsuario,
  consultarTurmas,
  editarCamposContrato,
  deletarFormando,
  adicionarFormando,
  editarFormando,
  editarFormandoEUsuario,
  obterFormandosPeloContrato,
  obterContratoPeloUsuario,
})(Formandos);
